
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Lager 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21.5 21.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.75 21.5A10.75 10.75 0 1121.5 10.75 10.76 10.76 0 0110.75 21.5zm0-20A9.25 9.25 0 1020 10.75a9.26 9.26 0 00-9.25-9.25z"}}),_c('path',{attrs:{"d":"M7.41 7A1.1 1.1 0 018.5 8.08a1.09 1.09 0 01-2.17 0A1.1 1.1 0 017.41 7zm0 .67a.41.41 0 00-.41.42.41.41 0 00.41.41.41.41 0 00.42-.41.42.42 0 00-.42-.42zm-.53-.18h1v1h-1zm7.08-.48a1.082 1.082 0 11.24 2.15 1.082 1.082 0 11-.24-2.15zm.16 1.49a.42.42 0 00-.08-.83.42.42 0 00-.37.46.41.41 0 00.45.37zm-3.38 9.01a6.67 6.67 0 01-3-.71 6.79 6.79 0 01-3.08-3.05.751.751 0 011.35-.66 5.33 5.33 0 002.37 2.37 5.26 5.26 0 007-2.37.76.76 0 011-.34.74.74 0 01.33 1 6.66 6.66 0 01-3.89 3.4 6.75 6.75 0 01-2.08.36z"}}),_c('path',{attrs:{"d":"M13.53 7.5h1.14v1.14h-1.14z"}})])
          )
        }
      }
    